module.exports = __webpack_public_path__ + "img/case_bg.14f676e8.png";